import { Eye, X } from "lucide-react";
import { isStudentPreview, exitStudentPreview } from "../lib/api";

// Fixed banner shown while the instructor is previewing the app as a student.
export const StudentPreviewBar = () => {
  if (!isStudentPreview()) return null;
  return (
    <div
      data-testid="student-preview-bar"
      className="fixed bottom-0 inset-x-0 z-[80] bg-[var(--gold)] text-[var(--navy-on-gold)] px-4 py-2.5 flex items-center justify-center gap-4 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]"
    >
      <span className="flex items-center gap-2 text-sm font-bold">
        <Eye className="w-4 h-4" /> Viewing as student — this is what your students see
      </span>
      <button
        data-testid="exit-student-preview-btn"
        onClick={exitStudentPreview}
        className="inline-flex items-center gap-1.5 bg-[#0b1d3a] text-[#fff8e1] px-3 py-1.5 rounded-md text-xs font-semibold hover:opacity-90 transition-opacity"
      >
        <X className="w-3.5 h-3.5" /> Exit preview
      </button>
    </div>
  );
};
